import { render, staticRenderFns } from "./delivery-courier-tab.vue?vue&type=template&id=51c751ad&"
import script from "./delivery-courier-tab.vue?vue&type=script&lang=js&"
export * from "./delivery-courier-tab.vue?vue&type=script&lang=js&"
import style0 from "./delivery-courier-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51c751ad')) {
      api.createRecord('51c751ad', component.options)
    } else {
      api.reload('51c751ad', component.options)
    }
    module.hot.accept("./delivery-courier-tab.vue?vue&type=template&id=51c751ad&", function () {
      api.rerender('51c751ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/checkout/delivery-selector/delivery-courier-tab.vue"
export default component.exports